import React from 'react';

export default props => (
    <svg viewBox="0 0 38 38" {...props}>
        <path fill="#FFF"
              d="M28 13.5l-4 4V14c0-.55-.45-1-1-1h-6.18L28 24.18V13.5zM10.27 9L9 10.27 11.73 13H11c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.21 0 .39-.08.54-.18L26.73 28 28 26.73 10.27 9z"/>
    </svg>
);